import * as React from 'react';
import type { SVGProps } from 'react';

export const HDIinfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.12412 9H7.32412V5.4H6.12412V9ZM6.72412 4.2C6.89412 4.2 7.03672 4.1424 7.15192 4.0272C7.26672 3.9124 7.32412 3.77 7.32412 3.6C7.32412 3.43 7.26672 3.2874 7.15192 3.1722C7.03672 3.0574 6.89412 3 6.72412 3C6.55412 3 6.41172 3.0574 6.29692 3.1722C6.18172 3.2874 6.12412 3.43 6.12412 3.6C6.12412 3.77 6.18172 3.9124 6.29692 4.0272C6.41172 4.1424 6.55412 4.2 6.72412 4.2ZM6.72412 12C5.89412 12 5.11412 11.8424 4.38412 11.5272C3.65412 11.2124 3.01912 10.785 2.47912 10.245C1.93912 9.705 1.51172 9.07 1.19692 8.34C0.881721 7.61 0.724121 6.83 0.724121 6C0.724121 5.17 0.881721 4.39 1.19692 3.66C1.51172 2.93 1.93912 2.295 2.47912 1.755C3.01912 1.215 3.65412 0.7874 4.38412 0.4722C5.11412 0.1574 5.89412 0 6.72412 0C7.55412 0 8.33412 0.1574 9.06412 0.4722C9.79412 0.7874 10.4291 1.215 10.9691 1.755C11.5091 2.295 11.9365 2.93 12.2513 3.66C12.5665 4.39 12.7241 5.17 12.7241 6C12.7241 6.83 12.5665 7.61 12.2513 8.34C11.9365 9.07 11.5091 9.705 10.9691 10.245C10.4291 10.785 9.79412 11.2124 9.06412 11.5272C8.33412 11.8424 7.55412 12 6.72412 12Z"
      fill="#97E4B2"
    />
  </svg>
);
